import { useState } from 'react';

import { useTimerLogic } from '../game-status/components/play-game-statuses/hooks/use-timer-logic';

export const useRevealButton = (gameStatusName: string) => {
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [technicalDefeatError, setTechnicalDefeatError] = useState(false);

  const { isSuccess, showInnerTimer, setShowInnerTimer, closeUnusedRoomHandler, onExpire } =
    useTimerLogic({
      gameStatusName,
      setShowTimer,
      setShowCloseButton,
      setTechnicalDefeatError,
    });

  return {
    showCloseButton,
    showTimer,
    technicalDefeatError,
    isSuccess,
    showInnerTimer,
    setShowInnerTimer,
    closeUnusedRoomHandler,
    onExpire,
  };
};
